import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  navigationRoutesFeatureKey,
  State,
} from '../navigation-routes.reducer';

const selectState = createFeatureSelector<State>(navigationRoutesFeatureKey);

export const selectAppRoutingReady = createSelector(
  selectState,
  (state) => state.appRoutingReady,
);
